import Api from '@/services/Api'
import { ToastProgrammatic as Toast } from 'buefy'

const entity = '/aluno'

export default {

    Index(cargo, cargoId, page, nome, sobrenome, email) {
        
        var cargoRoute = cargo == 'diretor' ? "/diretorindex/" + cargoId : '';

        nome      = nome      == undefined ? "" : nome;
        sobrenome = sobrenome == undefined ? "" : sobrenome;
        email     = email     == undefined ? "" : email;

        return Api().get(
            `${entity}${cargoRoute}?page=${page}&nome=${nome}&sobrenome=${sobrenome}&email=${email}`
            )
        .then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },
    
    Info(uuid) {
        return Api().get(`${entity}/${uuid}`).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },


    Create(params) {
        return Api().post(`${entity}/`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    Update(uuid,params) {
        return Api().put(`${entity}/${uuid}`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    Delete(uuid) {
        return Api().delete(`${entity}/${uuid}`).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },


}
